export interface OptLogActionsTableLoaderParams {
  isLoading: boolean;
  isFetching: boolean;
  isPlaceholderData: boolean;
  hasQueryData: boolean;
}

/**
 * True when the table should show skeleton rows.
 * - Initial load: no data yet.
 * - Pagination / filter / sort change: fetching while `keepPreviousData` still holds the prior page.
 * Same-key poll refetches keep `isPlaceholderData` false so rows stay stable.
 */
export function shouldShowOptLogActionsTableLoader({
  isLoading,
  isFetching,
  isPlaceholderData,
  hasQueryData,
}: OptLogActionsTableLoaderParams): boolean {
  return (isLoading && !hasQueryData) || (isFetching && isPlaceholderData);
}
